module.exports = __webpack_public_path__ + "static/media/pin-start.7efaa55c.svg";